<template>
  <div>
    <ul class="lz-resource-grid" v-if="subSections.length">
      <resource-card
        v-for="item in subSections"
        :key="item.uid"
        :title="item.title"
        :is-hidden="item.show === false"
        :admin="isAdmin"
        @edit="$emit('edit', item)"
        @toggle="$emit('toggle', item)">
        <resource-action
          v-for="action in LinkActions(item)"
          :key="action.label"
          :icon="action.icon"
          :label="action.label"
          @click="OpenLink(action.link)" />
      </resource-card>
    </ul>
    <div class="lz-empty-state" v-else>
      <b-icon icon="collection-play" class="lz-empty-icon"></b-icon>
      <p>There aren't any training modules in this section yet.</p>
    </div>
  </div>
</template>

<script>
import resourceCard from '../resource-card.vue'
import resourceAction from '../resource-action.vue'

export default {
  name: 'ContentComponent',
  components: {
    resourceCard,
    resourceAction
  },
  props: {
    subSections: {
      type: Array,
      required: false,
      default: () => []
    },
    isAdmin: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    LinkActions(item) {
      return [
        { link: item.videoLink, icon: 'camera-video', label: 'Videos' },
        { link: item.filesLink, icon: 'files', label: 'Files' }
      ].filter((action) => action.link)
    },
    OpenLink(link) {
      // noopener: window.open does not imply it the way <a target="_blank"> does,
      // so without it the opened page keeps a handle on window.opener.
      window.open(link, '_blank', 'noopener')
    }
  }
}
</script>
